import PercentIcon from "assets/icons/PercentIcon";
import BasicSelect from "components/BasicInputs/BasicSelect";
import BasicTextInput from "components/BasicInputs/BasicTextInput";
import { useFormikContext } from "formik";
import { formatPrice } from "helpers";
import useCurrency from "helpers/useCurrency";
import IconLogoPerson2 from "assets/svg/IconLogoPerson2.svg";
import IconLogoBank from "assets/svg/IconLogoBank.svg";
import IconLogoCashier from "assets/svg/IconLogoCashier.svg";
import IconLogoFund from "assets/svg/IconLogoFund.svg";
import IconLogoCheque from "assets/svg/IconLogoCheque.svg";
import { useAppDispatch, useAppSelector } from "store/store";
import { apiFinancialsList } from "api/financialApi";
import { apiPersonsList } from "api/personApi";
import { apiChequesList } from "api/chequeApi";

export default function PrePay() {
  const data = useFormikContext<InstallmentData>();
  const { defCur } = useCurrency();
  const store = useAppSelector((x) => x);
  const dispatch = useAppDispatch();

  const token = store.businessReducer.business.token;

  const currency = data.values.currency?.en_title || defCur.en_title;
  const prePay = data.values.prePay || 0;
  const prePayType = data.values.prePayType || "percent";
  const totalPrice = data.values.totalPrice || 0;
  const final = prePayType === "currency" ? prePay : totalPrice * (prePay / 100);
  const prePaySourceType = data.values.prePaySourceType || "bank";

  const options = [
    { label: "بانک", value: "bank", icon: IconLogoBank },
    { label: "شخص", value: "person", icon: IconLogoPerson2 },
    { label: "چک", value: "cheque", icon: IconLogoCheque },
    { label: "خرج چک", value: "spendCheque", icon: IconLogoCheque, active: data.values.tab === 1 },
    { label: "تنخواه", value: "fund", icon: IconLogoFund },
    { label: "صندوق", value: "cashier", icon: IconLogoCashier },
  ];

  const inputs: { [key: string]: BasicSelectProps } = {
    bank: {
      options: store.financialReducer.banks,
      label: "انتخاب بانک",
      refreshList: () => dispatch(apiFinancialsList("bank", token)),
    },
    person: {
      options: store.personReducer.allPerson,
      label: "انتخاب شخص",
      refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
    },
    cheque: {
      options: store.personReducer.allPerson,
      label: "پرداخت کننده",
      refreshList: () => dispatch(apiPersonsList(token, "allPerson")),
    },
    spendCheque: {
      options: store.chequeReducer.cheques,
      label: "انتخاب چک",
      refreshList: () => dispatch(apiChequesList(token)),
    },
    fund: {
      options: store.financialReducer.funds,
      label: "انتخاب تنخواه",
      refreshList: () => dispatch(apiFinancialsList("fund", token)),
    },
    cashier: {
      options: store.financialReducer.cashiers,
      label: "انتخاب صندوق",
      refreshList: () => dispatch(apiFinancialsList("cashier", token)),
    },
  };

  const input = inputs[prePaySourceType];

  return (
    <div>
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <BasicTextInput
            type={prePayType === "percent" ? "number-native" : "price"}
            label="نرخ پیش پرداخت"
            style={{ padding: "0px 12px 0px 0px" }}
            val={prePay}
            onChange={(val) => data.setFieldValue("prePay", val)}
            prefix={
              <div className="w-24 my-2 border-r border-gray-200">
                <BasicSelect
                  containerStyle={{ minWidth: 70 }}
                  menuStyle={{ minWidth: 70 }}
                  btnStyle={{ border: "none", minWidth: 70 }}
                  defaultValue={prePayType}
                  onChange={(val) => {
                    data.setFieldValue("prePay", 0);
                    data.setFieldValue("prePayType", val);
                  }}
                  options={[
                    {
                      label: <PercentIcon style={{ transform: "scale(0.6)" }} color="#95A3B5" />,
                      value: "percent",
                    },
                    { label: <span className="text-[#95A3B5]">{currency}</span>, value: "currency" },
                  ]}
                />
              </div>
            }
          />
        </div>
        <div className="flex flex-wrap items-center gap-x-12 gap-y-4 ">
          <div className="flex items-center h-10 gap-2">
            <span className="text-dark-3">پیش پرداخت</span>
            <span>{formatPrice(final)}</span>
            <span className="text-dark-3">{currency}</span>
          </div>
          <div className="flex items-center h-10 gap-2">
            <span>مانده بازپرداخت</span>
            <span>{formatPrice(totalPrice - final)}</span>
            <span className="text-dark-3">{currency}</span>
          </div>
        </div>
      </div>
      {/* <div className="flex flex-wrap items-center justify-between gap-4 p-4 my-4 border-2 rounded-md border-slate-200">
        <div>
          <BasicSelect
            options={options.filter((x) => (x.active !== undefined ? x.active : true))}
            preferences={{ button: 2 }}
            menuStyle={{ minWidth: 300 }}
            noVirtual
            onChange={(val, option) => {
              data.setFieldValue("prePaySourceId", undefined);
              data.setFieldValue("prePaySourceType", val);
            }}
            defaultValue={prePaySourceType}
            label="نوع دریافت"
          />
        </div>
        <div className="w-52 md:w-80">
          <BasicSelect
            {...input}
            withSearch
            withRefresh
            defaultValue={data.values.prePaySourceId}
            onChange={(val) => data.setFieldValue("prePaySourceId", val)}
          />
        </div>
      </div> */}
    </div>
  );
}
